import { addClass } from './add'
import { removeClass } from './remove'
import { hasClass } from './has'

/* IE9 Safe toggle */
export const toggleClass = (el, cls) => {
  try {
    // * Throw errors unless required elements are provided.
    if (!el) throw Error('!!! ERROR (DOM.fns.classList.toggle): Unable to toggle class.  No element provided.', el)
    if (!cls) throw Error('!!! ERROR (DOM.fns.classList.toggle): Unable to toggle class.  No class provided.', el)

    hasClass(el, cls) ? removeClass(el, cls) : addClass(el, cls)
  } catch (error) {
    MK.captureException && MK.captureException(error)
    return null
  }
}
